
export function EditingInput({ text, setCurrentText }: { text: string; setCurrentText: (text: string) => void; }) {
    return (
        <textarea defaultValue={text} className="border-2 border-slate-300 rounded-md p-2" onChange={(e) => setCurrentText(e.target.value)} />
    );
}
